import { render, staticRenderFns } from "./JobRequirement.vue?vue&type=template&id=2dcdd25c&scoped=true"
import script from "./JobRequirement.vue?vue&type=script&lang=js"
export * from "./JobRequirement.vue?vue&type=script&lang=js"
import style0 from "../../css/newCreateProject.css?vue&type=style&index=0&id=2dcdd25c&prod&scoped=true&lang=css&external"
import style1 from "./JobRequirement.vue?vue&type=style&index=1&id=2dcdd25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdd25c",
  null
  
)

export default component.exports